import Vue from 'vue'

export default {
    UPDATE_LOGOS (state, value) {
        Vue.set(state, 'logos', value);
    },
  SET_LOGOS (state, value) {
        this.commit('UPDATE_LOGOS', value);
    },
    SET_SELECTED_LOGO (state,  value ) {
      Vue.set(state, 'selectedLogo', value);
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/logos/mutations.js